// A QR code drawn on a canvas, on its own light paper so any camera reads it in every theme. The
// text it encodes is always shown beside it by the screen, so the drawing itself is decorative.
import "./config";
import { useEffect, useRef } from "react";
import { View } from "tamagui";
import { renderQR } from "../lib/qr";

export interface QrCodeProps {
  /** What the code encodes (a deep link). */
  value: string;
  /** Width and height in px, quiet zone included. */
  size?: number;
}

export function QrCode({ value, size = 200 }: QrCodeProps): React.JSX.Element {
  const canvas = useRef<HTMLCanvasElement | null>(null);
  useEffect(() => {
    if (canvas.current !== null) void renderQR(canvas.current, value, size);
  }, [value, size]);
  return (
    <View
      render="canvas"
      ref={(node: unknown) => {
        canvas.current = node instanceof HTMLCanvasElement ? node : null;
      }}
      width={size}
      height={size}
      borderRadius="2"
      padding={10}
      backgroundColor="bottlePaper"
      aria-hidden
    />
  );
}
